import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-dashboard-help-center-card-skeleton',
  imports: [Skeleton],
  templateUrl: './dashboard-help-center-card-skeleton.html',
})
export class DashboardHelpCenterCardSkeleton {}
